module.exports = __webpack_public_path__ + "static/media/store.b6b4701b.PNG";